"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XjbInfoRequest = void 0;
var XjbInfoRequest = /** @class */ (function () {
    function XjbInfoRequest() {
    }
    return XjbInfoRequest;
}());
exports.XjbInfoRequest = XjbInfoRequest;
;
//# sourceMappingURL=xjbInfo.request.js.map